import matchRoute from "helpers/matchRoute";
import { useLocation } from "react-router-dom";

export default function useRoute(route, { optional = false } = {}) {
  const { pathname } = useLocation();
  const params = matchRoute(pathname, route);

  if (!params && !optional)
    throw new Error(`${pathname} does not match route: ${route.path}`);
  return params || {};
}
